// extracted by mini-css-extract-plugin
export default {"table":"PricingTable_table__2R4KB","center":"PricingTable_center__abA+t","bg-gray":"PricingTable_bg-gray__CyIT+"};